var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoVehicles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 205,
    viewBox: "0 0 206 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_64877)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.0499,
    cy: 41.5158,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.976,
    cy: 59.1769,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.456,
    cy: 68.2462,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200.069,
    cy: 98.318,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.6144,
    cy: 69.6784,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.1671,
    cy: 181.851,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.671,
    cy: 192.829,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.95,
    cy: 179.942,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 123.697,
    cy: 177.078,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 128.471,
    cy: 190.92,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 109.853,
    cy: 196.648,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 174.293,
    cy: 166.815,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 189.568,
    cy: 138.414,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 180.26,
    cy: 123.616,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 184.08,
    cy: 93.5446,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 191.955,
    cy: 77.3156,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 186.467,
    cy: 40.7998,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 73.8164,
    cy: 199.035,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 39.6855,
    cy: 194.262,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 44.459,
    cy: 185.908,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 13.4336,
    cy: 147.722,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 20.3554,
    cy: 132.925,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 2.69333,
    cy: 94.4995,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 21.5488,
    cy: 64.6665,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 25.3672,
    cy: 22.4226,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 61.8828,
    cy: 6.19333,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 108.422,
    cy: 24.8093,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.437,
    cy: 18.8425,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.476 150.347C169.421 150.347 168.566 149.493 168.566 148.438C168.566 147.384 169.421 146.529 170.476 146.529",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.51172 117.65C7.56621 117.65 8.42104 116.795 8.42104 115.741C8.42104 114.686 7.56621 113.831 6.51172 113.831",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5312 22.4226C75.5857 22.4226 76.4406 21.5678 76.4406 20.5133C76.4406 19.4588 75.5857 18.604 74.5312 18.604",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.832 15.7399C119.778 15.7399 118.923 16.5948 118.923 17.6493C118.923 18.7038 119.778 19.5586 120.832 19.5586",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3301 166.934H16.2967M26.3207 155.836V157.388M38.0153 166.934H39.5666M26.3207 176.481V178.271M26.3207 180.658V186.982M21.9053 166.934C24.8887 166.934 26.44 162.638 26.44 162.638C26.44 162.638 26.9173 166.934 30.736 166.934C29.0176 166.934 26.5593 168.486 26.3207 171.588C26.3207 171.588 26.0428 169.048 25.1273 168.128C24.363 167.359 21.9053 166.934 21.9053 166.934Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.709 28.0596L182.742 28.0596M172.599 43.8115L172.718 37.6062M161.024 28.0596L159.472 28.0596M172.599 18.7516L172.599 6.57973M177.134 28.0596C174.15 28.0596 172.599 32.3556 172.599 32.3556C172.599 32.3556 172.122 28.0596 168.303 28.0596C170.021 28.0596 172.48 26.5083 172.718 23.4056C172.718 23.4056 172.996 25.9458 173.912 26.8663C174.676 27.6348 177.134 28.0596 177.134 28.0596Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.3071,
    cy: 95.3469,
    rx: 68.2583,
    ry: 67.6616,
    fill: "#787E8C",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.565 95.3469C166.565 132.155 136.461 162.009 99.3071 162.009C62.1531 162.009 32.0488 132.155 32.0488 95.3469C32.0488 58.539 62.1531 28.6853 99.3071 28.6853C136.461 28.6853 166.565 58.539 166.565 95.3469Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_31_64877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63 41V51H143V41",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5 137V130H142.5V137",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102 51V130",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 89.5H145.5",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 89,
    r: 27,
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5 25.0334V37.9666C82.5 39.4798 80.9602 41 78.6646 41H45.3354C43.0398 41 41.5 39.4798 41.5 37.9666V25.0334C41.5 23.5202 43.0398 22 45.3354 22H78.6646C80.9602 22 82.5 23.5202 82.5 25.0334Z",
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.743 141.126V153.989C162.743 155.651 161.394 157 159.729 157H122.029C120.364 157 119.016 155.651 119.016 153.989V141.126C119.016 139.463 120.364 138.114 122.029 138.114H159.729C161.394 138.114 162.743 139.463 162.743 141.126Z",
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.73 40.8861H122.456C120.791 40.8861 119.442 39.5367 119.442 37.8724V25.0137C119.442 23.3493 120.791 22 122.456 22H159.73C161.394 22 162.743 23.3493 162.743 25.0137V37.8724C162.743 39.537 161.394 40.8861 159.73 40.8861ZM58.178 84.5683V94.3587C58.178 96.023 56.8287 97.3724 55.1644 97.3724H37.582C35.9177 97.3724 34.5684 96.023 34.5684 94.3587V84.5683C34.5684 82.9039 35.9177 81.5546 37.582 81.5546H55.1644C56.8287 81.5546 58.178 82.9039 58.178 84.5683Z",
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6566 157H43.3984C41.7341 157 40.3848 155.651 40.3848 153.986V141.128C40.3848 139.463 41.7341 138.114 43.3984 138.114H79.6566C81.321 138.114 82.6703 139.463 82.6703 141.128V153.986C82.6703 155.651 81.321 157 79.6566 157ZM169.5 84.5684V94.3588C169.5 96.0231 168.151 97.3724 166.487 97.3724H148.904C147.24 97.3724 145.891 96.0231 145.891 94.3588V84.5684C145.891 82.904 147.24 81.5547 148.904 81.5547H166.487C168.151 81.5547 169.5 82.904 169.5 84.5684Z",
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 29H73.5",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 145H73.5",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.5 29H153",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.5 145H153",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5 87H53.5",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.5 87H165.5",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5 33L67.5 33",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5 149L67.5 149",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135 33L147 33",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135 149L147 149",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5 91L49.5 91",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.5 91L161.5 91",
    stroke: "#787E8C",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91.5 96C91.5 89.9249 96.4249 85 102.5 85C108.575 85 113.5 89.9249 113.5 96V105H91.5V96Z",
    fill: "white",
    stroke: "#194590",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 78,
    r: 8,
    fill: "white",
    stroke: "#194590",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.089 96.5164C105.816 96.1308 105.407 95.7957 104.87 95.5199C104.367 95.2608 103.606 95.0035 102.544 94.7326C101.419 94.4457 100.9 94.1892 100.663 94.025C100.385 93.8317 100.25 93.5565 100.25 93.1833C100.25 92.7917 100.404 92.4932 100.722 92.2698C101.051 92.0379 101.521 91.9252 102.161 91.9252C102.771 91.9252 103.231 92.0643 103.567 92.3504C103.924 92.6551 104.098 93.0706 104.098 93.6211C104.098 93.8897 104.388 94.1075 104.746 94.1075H105.758C106.116 94.1075 106.407 93.8897 106.407 93.6211C106.407 92.6613 106.08 91.8811 105.435 91.3022C104.987 90.8991 104.414 90.6125 103.723 90.4458C103.454 90.3808 103.269 90.1958 103.269 89.9835V89.4865C103.269 89.2179 102.979 89 102.621 89H101.753C101.395 89 101.105 89.2179 101.105 89.4865V89.9705C101.105 90.1856 100.915 90.374 100.64 90.4355C99.9851 90.582 99.4289 90.8281 98.9786 91.1708C98.2907 91.6948 97.9418 92.3777 97.9418 93.2C97.9418 93.9835 98.2607 94.6371 98.8901 95.143C99.4897 95.6247 100.463 96.0198 101.847 96.3455C103.013 96.6486 103.534 96.9152 103.766 97.0856C104.046 97.2919 104.183 97.5568 104.183 97.8959C104.183 98.2733 104.014 98.5572 103.651 98.7886C103.261 99.037 102.754 99.1577 102.102 99.1577C101.346 99.1577 100.788 99.018 100.394 98.7309C100.005 98.4474 99.8166 98.0509 99.8166 97.5194C99.8166 97.2508 99.5263 97.033 99.1683 97.033H98.1483C97.7901 97.033 97.5 97.2508 97.5 97.5194C97.5 98.4841 97.8758 99.2646 98.6182 99.8393C99.1334 100.238 99.7935 100.515 100.589 100.667C100.876 100.722 101.079 100.914 101.079 101.137V101.514C101.079 101.782 101.37 102 101.728 102H102.587C102.945 102 103.235 101.782 103.235 101.514V101.114C103.235 100.895 103.433 100.706 103.715 100.646C104.396 100.502 104.971 100.259 105.434 99.918C106.141 99.3976 106.5 98.7129 106.5 97.8832C106.5 97.3624 106.362 96.9026 106.089 96.5164Z",
    fill: "#194590"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_64877"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 205,
    height: 205,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_31_64877"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 137,
    height: 137,
    fill: "white",
    transform: "translate(33.5 21)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoVehicles);
export default __webpack_public_path__ + "static/media/no-vehicles.ebe467af4c4f27fd232d2d7f0756c063.svg";
export { ForwardRef as ReactComponent };